import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { fetchDistrictOptions, fetchRegionOptions, type GeoOptions } from './geoApi'

const EMPTY: GeoOptions = { options: [], truncated: false }
const STALE_MS = 5 * 60_000

/**
 * @param activeOnly `false` — nofaol yozuvlar ham kerak (mavjud qiymatning
 *   nomini ko'rsatish uchun); `true` — tanlash uchun ro'yxat.
 */
export function useRegionOptions(activeOnly: boolean, enabled = true) {
  const query = useQuery({
    queryKey: queryKeys.geo.regionOptions(activeOnly),
    queryFn: () => fetchRegionOptions(activeOnly),
    staleTime: STALE_MS,
    enabled,
  })
  return { ...(query.data ?? EMPTY), isPending: query.isPending && enabled, isError: query.isError }
}

export function useDistrictOptions(regionId: string | null, activeOnly: boolean) {
  const query = useQuery({
    queryKey: queryKeys.geo.districtOptions(regionId, activeOnly),
    queryFn: () => fetchDistrictOptions(regionId ?? '', activeOnly),
    staleTime: STALE_MS,
    enabled: regionId !== null,
  })
  return {
    ...(query.data ?? EMPTY),
    isPending: query.isPending && regionId !== null,
    isError: query.isError,
  }
}
